import { Modal } from 'antd';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { DeleteButton } from '../Buttons';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';
import { InvoiceSituation } from '@/core/domain/invoice/invoices/invoices.enums';
import { useInvoiceFormContext } from '@/components/Fiscal/Invoice/InvoiceFormProvider';
import { useDeleteInvoice } from '@/core/domain/invoice/invoice/invoice.hooks';

const InvoiceDeleteButton = () => {
  const {
    invoice: { data: invoice },
  } = useInvoiceFormContext();

  const history = useHistory();

  const deleteInvoice = useDeleteInvoice();

  const handleRemoveClick = async () => {
    Modal.confirm({
      title: 'Você deseja realmente excluir essa nota fiscal?',
      content:
        'Ao excluir a nota fiscal, todas as suas informações serão perdidas permanentemente. Ainda sim deseja continuar?',
      okText: 'Excluir',
      onOk: async () => {
        if (invoice?.id) {
          await deleteInvoice.mutateAsync(invoice?.id);

          history.push(
            `/app/fiscal/invoice?invoiceType=${invoice?.invoiceType}&companyId=${invoice?.companyId}`,
          );
        }
      },
    });
  };

  return (
    <DeleteButton
      block
      onClick={handleRemoveClick}
      disabled={
        (invoice?.situation !== InvoiceSituation.IN_TYPING &&
          invoice?.situation !== InvoiceSituation.VALIDATED) ||
        !hasPermissions([Authorities.FISCAL_INVOICE_DELETE])
      }
      loading={deleteInvoice.isLoading}
    >
      Excluir
    </DeleteButton>
  );
};

export default InvoiceDeleteButton;
